import { Tag } from "primereact/tag";

import "./style.scss";

const TagUi = (props) => <Tag {...props} className={`tag-ui ${props.className} ${props.bgColor}`} />;

export default TagUi;
